import { IError, IErrorMessageObject } from './interface/iError';
import { __ } from '../translations';

export const getStreamConcurrencyDisplayError = (error: IError): IErrorMessageObject => {
    if (!error?.code) {
        return {
            errorTitle: __('general_error_message_title'),
            errorDesc: __('general_error_message_desc'),
            recall: false,
        };
    }

    const recallErrors = ['9006', 'EXPIRED_IDENTITY_TOKEN', 'INVALID_OR_EXPIRED_AUTH_TOKEN'];
    if (recallErrors.includes(error.code)) {
        return { errorTitle: null, errorDesc: null, recall: true };
    }

    return {
        errorTitle: __(`err_msg_title_${error.code}`),
        errorDesc:
            error?.code === 'LOCK_QUOTA_REACHED' || error?.code === 'LOCK_ALREADY_ISSUED'
                ? __(`err_msg_desc_${error?.code}`, { accountId: error?.description?.match(/accountId:\s*(\d+)/)?.[1] })
                : __(`err_msg_desc_${error.code}`),
        recall: false,
    };
};
